import { NotImplementedError } from "../../../../../errors";
import { normalizeUserEmail, OVERVIEW_VIEWER_EMAIL_FILTER, parseDateFilter } from "../../../../../models/looker/modules/overview";
import { PromiseHandler } from "../../../../../handlers";
import { FILTER_OPTIONS_ADVERTISER_QUERY } from "../query";
export default class LookerOverviewAdvertiserFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-overview-advertiser-filter");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const queryBody = {
            ...FILTER_OPTIONS_ADVERTISER_QUERY,
            filters: {
                "explore_overview.flt_date_range": parseDateFilter(dateFilter)
            }
        };
        // The advertiser list is intentionally NOT filtered by media type: callers
        // rely on getting every advertiser (plus its full media-type set via
        // `mediaTypesById`) so they can grey out — rather than drop — advertisers
        // that have no data for the currently selected media type(s).
        // Fail closed: the advertiser list is partner-scoped exclusively by the
        // user email filter. Without a usable email the Looker query would return
        // every partner's advertisers (a cross-tenant leak), so we refuse to run it.
        const userEmailFilter = filters.where?.find((filter) => filter.field === "userEmail");
        const userEmail = normalizeUserEmail(userEmailFilter?.value);
        if (!userEmail) {
            throw new Error("User email is required");
        }
        queryBody.filters[OVERVIEW_VIEWER_EMAIL_FILTER] = userEmail;
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch overview dashboard advertiser filter options");
        }));
    }
    /**
     * Builds the master advertiser list plus a map of advertiser id -> the media
     * types (product groups) that advertiser has data for. The list is NOT
     * filtered by media type so the caller can show every advertiser and grey out
     * the ones that don't belong to the currently selected media type(s).
     */
    formatResponse(data) {
        const advertiserMap = new Map();
        data.forEach((row) => {
            const id = row["meta_inst.advertiser_id"];
            if (!id) {
                return;
            }
            const name = row["meta_inst.advertiser_name"] || id;
            const productGroup = row["explore_overview.product_group"];
            if (!advertiserMap.has(id)) {
                advertiserMap.set(id, { name, mediaTypes: new Set() });
            }
            if (productGroup) {
                advertiserMap.get(id).mediaTypes.add(productGroup);
            }
        });
        const options = [];
        const mediaTypesById = {};
        advertiserMap.forEach((value, id) => {
            options.push({ id, name: value.name });
            mediaTypesById[id] = Array.from(value.mediaTypes);
        });
        return { options, mediaTypesById };
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Advertiser.js.map